var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPerson48Line = function SvgIconPerson48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.999 24.7a7.7 7.7 0 1 1 7.7-7.7 7.72 7.72 0 0 1-7.7 7.7Zm0-12a4.3 4.3 0 1 0 4.3 4.3 4.31 4.31 0 0 0-4.3-4.3ZM37.728 37h-3.4v-5.4a1.9 1.9 0 0 0-1.9-1.9h-16.8a1.902 1.902 0 0 0-1.9 1.9V37h-3.4v-5.4a5.3 5.3 0 0 1 5.3-5.3h16.8a5.3 5.3 0 0 1 5.3 5.3V37Z",
    fill: "current"
  })));
};
export default SvgIconPerson48Line;